// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import RichTextBlock from './ev-rich-text-block'
import SingleColumnRichText from './platinum-modules/single-column-rich-text'
import { Fragment } from 'react'
import TwoColumnRichText from './platinum-modules/two-column-rich-text'
import { brand } from '../redux/app-selectors'
import { connect } from 'react-redux'
import { removeWhitespaceAndSpecialChars } from './helpers/commons'

const RichText = (props) => {
  const { content: document, contentTwo: documentTwo, heading, variant = undefined } = props
  if (variant === 'platinum') {
    if (document && !documentTwo) {
      return <SingleColumnRichText {...props} />
    }

    if (document && documentTwo) {
      return <TwoColumnRichText {...props} />
    }
    if (heading) {
      return <SingleColumnRichText {...props} />
    } else {
      return <Fragment />
    }
  }
  return (
    <div id={removeWhitespaceAndSpecialChars(props.name)}>
      <RichTextBlock {...props} />
    </div>
  )
}

export default connect((state, props) => {
  return {
    brand: brand(state),
    ...props,
  }
})(RichText)
